module.exports = __webpack_public_path__ + "img/mynewsimg4.bd65a31e.png";